import {
  Icon,
  PrimaryButton,
  SecondaryButton,
  useTranslation,
} from '@testsigma/atoms';
import { useCallback } from 'react';

interface UploadActionButtonsProps {
  isCreateNew: boolean;
  isUploadInProgress: boolean;
  onCreate: () => void;
  onUpdate: () => void;
  onCancel: () => void;
  hasError: boolean;
}

export const UploadActionButtonsPanel: React.FC<UploadActionButtonsProps> = ({
  isCreateNew,
  isUploadInProgress,
  onCreate,
  onUpdate,
  onCancel,
  hasError,
}) => {
  const { t } = useTranslation();

  const onClickSave = useCallback(() => {
    if (isCreateNew) {
      onCreate();
    } else {
      onUpdate();
    }
  }, [onCreate, onUpdate, isCreateNew]);

  return (
    <div className='flex gap-x-3'>
      <PrimaryButton
        isDisabled={isUploadInProgress || hasError}
        onClick={onClickSave}>
        <>
          {isUploadInProgress ? (
            <div className='flex gap-x-1.5 items-center'>
              <Icon className=' text-base flex animate-spin' name='loader' />
              {t('common.uploading')}
            </div>
          ) : (
            t('common.upload')
          )}
        </>
      </PrimaryButton>
      <SecondaryButton onClick={onCancel}>{t('common.cancel')}</SecondaryButton>
    </div>
  );
};
